import { default as GALLERY_CONSTS } from '../../common/constants';
export var formatTitle = function (title) {
    return title
        .replace(/_/g, ' ')
        .split(' ')
        .map(function (word) { return word[0].toUpperCase() + word.substr(1).toLowerCase(); })
        .join(' ');
};
export var createOptions = function (constName) {
    return Object.entries(GALLERY_CONSTS[constName]).map(function (_a) {
        var title = _a[0], value = _a[1];
        return ({
            value: value,
            title: formatTitle(title),
        });
    });
};
//# sourceMappingURL=utils.js.map